import React, {useState, useEffect} from 'react'
import { useHistory } from "react-router-dom";
import Slider from "react-slick";
import {Transition} from 'semantic-ui-react'

import {productionBaseUrl} from '../config/const';
import styles from './DepartmentDetail.module.scss'
import './DepartmentDetail.css'

const DepartmentDetail = (props) => {
    const history = useHistory();

    const gotoDeparmentInfo = () => {
        history.push("/department/"+props.production.id);
    }

    const [isPageVisible, setPageVisible] = useState(false);
    const [steps, setSteps] = useState([false]);

    useEffect(() => {
        setPageVisible(true);
    });

    function setStepVisible(index, visible) {
        const stepsCopy = [...steps];
        stepsCopy[index] = visible;
        setSteps(stepsCopy);
    }

    const sliderSetting = {
        arrows: false,
        dots: true,
        autoplay: true
    }

    const sliderMobileSetting = {
        arrows: false,
        dots: false,
        autoplay: true,
        swipe: false
    }

    const getLanguageClass = () => {
        switch(props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    return (
        <>
            <div className={`department_detail ${styles.department_detail} ${styles.desktop} ${getLanguageClass()}`}>
                <Transition visible={isPageVisible} animation='fade' duration={1000} onShow={() => {
                    setStepVisible(0, true)
                }}>
                    <div>
                        {props.showScrollDown ?
                        <div className={styles.scroll_down}>
                            <div className={styles.text}>SCROLL</div>
                            <div className={styles.arrow_block}>
                                <div className={`arrow down ${styles.arrow} ${styles.top}`}></div>
                                <div className={`arrow down ${styles.arrow} ${styles.down}`}></div>
                            </div>
                        </div>
                          : null }

                        <div className={styles.content}>
                            <Slider {...sliderSetting}>
                                {
                                    props.production.images.filter(image=>image.apply).filter(item=>item.type==="gray_desktop").map((item, index) => {
                                        return (
                                          <div className={styles.pic_container}>
                                              <div className={styles.info_link} key={index} onClick={() => {
                                                  gotoDeparmentInfo();
                                              }}></div>
                                              <img src={productionBaseUrl + item.path}/>
                                          </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                </Transition>
            </div>

            <div className={`department_detail ${styles.department_detail} ${styles.mobile} ${getLanguageClass()}`}>
                <div className={styles.content}>
                    <div className={styles.slider_wrapper}>
                      <Slider {...sliderMobileSetting}>
                          {
                              props.production.images.filter(image=>image.apply).filter(item => item.type === "mobile").map((item, index) => {
                                  return <div key={index} className={styles.content_slide}>
                                      <img
                                      src={productionBaseUrl + item.path}/>
                                  </div>
                              })
                          }
                      </Slider>
                    </div>
                    <div className={styles.page}>
                        <div className={styles.page_title}>{props.production.name}</div>
                    </div>
                    <div className={styles.direct_link_container} onClick={gotoDeparmentInfo}>
                        <div className={styles.direct_link_line}></div>
                        <div className={styles.direct_link}>See More</div>
                    </div>
                </div>
            </div>
        </>);
};

export default DepartmentDetail;
